import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-back-icon',
  templateUrl: './lib-back-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibBackIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
